import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { HITCLUB, COMPANY } from 'actions/Base';
import { moveItemInArray } from "utils/helpers.js";

export const INITIAL_STATE = {
  selectedHitClub: '',
  hitClubsMenu: [],
  hitClubs: [],
  underClubsIds: [],
  isLoading: false,
  hitClubMembers: {
    content: [],
    totalElements: 0, 
    number: 0,
    numberOfElements: 0,
    totalPages: 0
  },
  hitClubMembersRequests: [],
  hitClubHitEvents: {
    content: []
  },
  hitMemberLogs: {},
  feeds: {},
  hitEventFeeds: {},
  hitClubHitEventsDetailPanes: [],
  hitClubProducts: {
    content: []
  },
  hitClubProductsDetailPanes: [],
  hitClubProductGroups: {},
  hitClubProductGroupOffers: {},
  hitElectionPosts: {},
  hitElectionCandidacies: {},
  hitClubActiveSubMemberships: {}
};

export const onGetHitClubsMenuRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubsMenuFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubsMenuSuccess = (state, { payload }) => {

  return { 
    ...state, 
    isLoading: false, 
    hitClubsMenu: payload
  }
};

export const onGetHitClubRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubSuccess = (state, { payload }) => {

  return { 
    ...state, 
    isLoading: false, 
    hitClubs: [ 
      ...state.hitClubs.filter((hitClub => hitClub?.hitClubId !== payload.hitClubId)),
      payload 
    ]
  }
};

export const onGetHitClubsRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubsFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubsSuccess = (state, { payload }) => {
  
  const ids = new Set(payload.underClubs.map(o => o.id));
  const newHitClubs = payload.hitClubUser.filter(hitClubUser => !ids.has(hitClubUser.id)).concat(payload.underClubs)

  return { 
    ...state, 
    isLoading: false, 
    hitClubs: newHitClubs,
    underClubsIds: [ ...payload.underClubs.map(club => club.id) ]
  }
};

export const onGetHitClubMembersRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubMembersFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubMembersSuccess = (state, { payload }) => {  
  return { 
    ...state, 
    isLoading: false, 
    hitClubMembers: payload.data,
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId === payload?.data?.content[0]?.hitClub?.hitClubId ? 
        { ...hitClub, numberOfMembers: payload?.updateNumberOfMembers ? payload?.data?.totalElements : hitClub.numberOfMembers } : hitClub
    ) 
  };
}

export const onGetHitClubMembersRequestsRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubMembersRequestsFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubMembersRequestsSuccess = (state, { payload }) => ({ ...state, isLoading: false, hitClubMembersRequests: payload });

export const onGetHitClubHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubHitEventSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    // hitClubHitEvents: {
    //   ...state.hitClubHitEvents,
    //   content: state.hitClubHitEvents.content.map(hitEvent => 
    //     (hitEvent || {}).hitEventId === payload.hitEventId ? 
    //       { ...hitEvent, ...payload } : hitEvent
    //   )
    // },
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.hitEventId}`] : { ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.hitEventId}`], ...payload }
    }
  })
}

export const onGetHitClubHitEventsRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubHitEventsFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubHitEventsSuccess = (state, { payload }) => ({ ...state, isLoading: false, hitClubHitEvents: payload });

export const onCreateHitClubRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onCreateHitClubFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitClubSuccess = (state, { payload }) => ({ ...state, isLoading: false, hitClubs: [...state.hitClubs, {...payload}] });

export const onEditHitClubRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onEditHitClubFailure = (state) => ({ ...state, isLoading: false });
export const onEditHitClubSuccess = (state, { payload }) => {
  let currentHitClubs = _.cloneDeep(_.get(`hitClubs`)(state) || {});

  if(currentHitClubs) {
    const hitClubIndex = currentHitClubs.findIndex((hitClub) => (
      (hitClub || {}).hitClubId === payload.hitClubId
    ));

    if(hitClubIndex > -1) {
      currentHitClubs[hitClubIndex] = payload
      state.isLoading = false
      return _.set(`hitClubs`, currentHitClubs)(state);
    }
  
  }

  return ({ ...state, isLoading: false });

};

export const onCreateHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onCreateHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitEventSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitClubHitEvents: { 
      ...state.hitClubHitEvents,
      content: [payload].concat(state.hitClubHitEvents.content||[])
    }
  };
};

export const onEditHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onEditHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onEditHitEventSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitClubHitEvents: { 
      ...state.hitClubHitEvents,
      content: state.hitClubHitEvents.content.map(hitEvent => 
        (hitEvent || {}).hitEventId === payload.hitEventId ? 
          { ...hitEvent, ...payload } : hitEvent
      )
    },  
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId === payload.hitClub.hitClubId ? 
        { ...hitClub, payload } : hitClub
    )
  };

};

export const onApproveMemberRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onApproveMemberFailure = (state) => ({ ...state, isLoading: false });
export const onApproveMemberSuccess = (state, { payload }) => {

  if(payload?.hitMemberStatus === "MEMBER") {
    return ({
      ...state,
      isLoading: false, 
      hitClubs: state.hitClubs.map(hitClub => 
        (hitClub || {}).hitClubId === payload.hitClub.hitClubId ? 
          { ...hitClub, numberOfMembers: hitClub.numberOfMembers+1 } : hitClub
      ),
      hitClubMembers: {
        ...state.hitClubMembers,
        content: [ 
          ...state.hitClubMembers.content.filter((member => member?.hitMemberId !== payload.hitMemberId)),
          payload
        ],
        totalElements: state.hitClubMembers.totalElements+1, 
        number: state.hitClubMembers.number+1,
        numberOfElements: state.hitClubMembers.numberOfElements+1,
      }
    })
  }
  else {
    return ({
      ...state,
      isLoading: false, 
      hitClubs: state.hitClubs.map(hitClub => 
        (hitClub || {}).hitClubId === payload.hitClub.hitClubId ? 
          { ...hitClub } : hitClub
      ),
      hitClubMembers: {
        ...state.hitClubMembers,
        content: [ 
          ...state.hitClubMembers.content.filter((member => member?.hitMemberId !== payload.hitMemberId)),
          payload
        ]
      }
    })
  }
  
};

export const onApproveMembersRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onApproveMembersFailure = (state) => ({ ...state, isLoading: false });
export const onApproveMembersSuccess = (state, { payload }) => {
  
  let numberOfMembers = 0

  payload.success.map((hitMember, index) => { 
    if(hitMember?.hitMemberStatus === "MEMBER") {
      numberOfMembers+1
    }
  })

  const memberIdsToRemove = payload.success.map((hitMember, index) => { 
    return hitMember.hitMemberId
  })
  
  return ({
    ...state,
    isLoading: false, 
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId === payload.success[0].hitClub.hitClubId ? 
        { ...hitClub, numberOfMembers: hitClub.numberOfMembers+numberOfMembers } : hitClub
    ),
    hitClubMembers: {
      ...state.hitClubMembers,
      content: [ 
        ...state.hitClubMembers.content.filter((member => !memberIdsToRemove.includes(member.hitMemberId) )),
        ...payload.success
      ],
      totalElements: numberOfMembers > 0 ? state.hitClubMembers.totalElements+numberOfMembers : state.hitClubMembers.totalElements,
      number: numberOfMembers > 0 ? state.hitClubMembers.number+numberOfMembers : state.hitClubMembers.number,
      numberOfElements: numberOfMembers > 0 ? state.hitClubMembers.numberOfElements+numberOfMembers : state.hitClubMembers.numberOfElements,
    }
  })

};

export const onCreateHitClubOwnerRequest = (state) => ({ ...state, isLoading: true });
export const onCreateHitClubOwnerFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitClubOwnerSuccess = (state, { payload }) => {

  let hitClubs = _.cloneDeep(_.get(`hitClubs`)(state) || {});

  if(hitClubs) {
    const currentHitClubIndex = hitClubs.findIndex((hitClub) => (
      (hitClub || {}).hitClubId === payload.hitClubId
    ));

    if(currentHitClubIndex > -1) {
      hitClubs[currentHitClubIndex].hitClubUsers = payload.hitClubUsers
      state.isLoading = false
      return _.set(`hitClubs`, hitClubs)(state);
    }
  
  }

  state.isLoading = false
  return state;
};

export const onUpdateHitClubOwnerRequest = (state) => ({ ...state, isLoading: true });
export const onUpdateHitClubOwnerFailure = (state) => ({ ...state, isLoading: false });
export const onUpdateHitClubOwnerSuccess = (state, { payload }) => {

  let hitClubs = _.cloneDeep(_.get(`hitClubs`)(state) || {});

  if(hitClubs) {
    const currentHitClubIndex = hitClubs.findIndex((hitClub) => (
      (hitClub || {}).hitClubId === payload.hitClubId
    ));

    if(currentHitClubIndex > -1) {
      hitClubs[currentHitClubIndex].hitClubUsers = [hitClubs[currentHitClubIndex].hitClubUsers, ...payload.hitClubUsers]
      state.isLoading = false
      return _.set(`hitClubs`, hitClubs)(state);
    }
  
  }

  state.isLoading = false
  return state;
};

export const onCreateHitClubOwnerOtherRequest = (state) => ({ ...state, isLoading: true });
export const onCreateHitClubOwnerOtherFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitClubOwnerOtherSuccess = (state, { payload }) => {
  console.log('payload', payload)
  let hitClubs = _.cloneDeep(_.get(`hitClubs`)(state) || {});

  if(hitClubs) {
    const currentHitClubIndex = hitClubs.findIndex((hitClub) => (
      (hitClub || {}).hitClubId === payload.data.hitClub.hitClubId
    ));

    if(currentHitClubIndex > -1) {
      hitClubs[currentHitClubIndex].hitClubUsers.push(payload.data)
      state.isLoading = false
      return _.set(`hitClubs`, hitClubs)(state);
    }
  
  }

  state.isLoading = false
  return state;
};

export const onRemoveHitClubOwnerRequest = (state) => ({ ...state, isLoading: true });
export const onRemoveHitClubOwnerFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitClubOwnerSuccess = (state, { payload }) => {

  let hitClubs = _.cloneDeep(_.get(`hitClubs`)(state) || {});

  if(hitClubs) {
    const currentHitClubIndex = hitClubs.findIndex((hitClub) => (
      (hitClub || {}).hitClubId === payload.hitClubId
    ));

    if(currentHitClubIndex > -1) {
      hitClubs[currentHitClubIndex] = payload
      state.isLoading = false
      return _.set(`hitClubs`, hitClubs)(state);
    }
  
  }

  state.isLoading = false
  return state;
};

export const onEditHitMemberRequest = (state) => ({ ...state, isLoading: true });
export const onEditHitMemberFailure = (state) => ({ ...state, isLoading: false });
export const onEditHitMemberSuccess = (state, { payload }) => { 
  let currentHitClubMembers = _.cloneDeep(_.get(`hitClubMembers`)(state) || {});

  if(currentHitClubMembers.content) {
    const hitClubMembersIndex = currentHitClubMembers.content.findIndex((member) => (
      (member || {}).hitMemberId === payload.hitMemberId
    ));

    if(hitClubMembersIndex > -1) {
      currentHitClubMembers.content[hitClubMembersIndex] = payload
      state.isLoading = false
      return _.set(`hitClubMembers`, currentHitClubMembers)(state);
    }
  
  }

  state.isLoading = false
  return state;
};

export const onRemoveHitMemberRequest = (state) => ({ ...state, isLoading: true });
export const onRemoveHitMemberFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitMemberSuccess = (state, { payload }) => {
  const { hitMemberId } = payload

  let currentHitClubMembers = _.cloneDeep(_.get(`hitClubMembers`)(state) || {});

  if(currentHitClubMembers.content) {
    currentHitClubMembers.content.splice(currentHitClubMembers.content.findIndex((item) => {
      return item.hitMemberId.toString() === hitMemberId.toString();
    }), 1);

    state.isLoading = false
    return _.set(`hitClubMembers`, currentHitClubMembers)(state);
  
  }

  state.isLoading = false
  return state;

};

export const onCreateTicketRequest = (state) => ({ ...state, isLoading: true });
export const onCreateTicketFailure = (state) => ({ ...state, isLoading: false });
export const onCreateTicketSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.entityId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`], 
        tickets: {
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`]?.tickets?.content?.concat([payload])
        }
      } 
    }
  };
};

export const onEditTicketRequest = (state) => ({ ...state, isLoading: true });
export const onEditTicketFailure = (state) => ({ ...state, isLoading: false });
export const onEditTicketSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.entityId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`], 
        tickets: {
          ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`].tickets,
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`].tickets.content.map(ticket => 
            (ticket || {}).productOfferId === payload.productOfferId ?  
            { ...ticket, ...payload } : ticket
          )
        }
      } 
    }
  };

};

export const onGetEditTicketInformationRequest = (state) => ({ ...state, isLoading: true });
export const onGetEditTicketInformationFailure = (state) => ({ ...state, isLoading: false });
export const onGetEditTicketInformationSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.entityId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`], 
        tickets: {
          ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`].tickets,
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.entityId}`].tickets.content.map(ticket => 
            (ticket || {}).productOfferId === payload.productOfferId ?  
            { ...ticket, ...payload } : ticket
          )
        }
      } 
    }
  };

};

export const onGetTicketQuestionsRequest = (state) => ({ ...state, isLoading: true });
export const onGetTicketQuestionsFailure = (state) => ({ ...state, isLoading: false });
export const onGetTicketQuestionsSuccess = (state, { payload }) => {

  const { data, productOfferId, hitEventId } = payload

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${hitEventId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`], 
        tickets: {
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`].tickets.content.map(ticket => 
              (ticket || {}).productOfferId === productOfferId ?  
              { ...ticket, dynamicInfo: { ...data } } : ticket
            )
        }
      } 
    }
  };

};


export const onCreateTicketQuestionsRequest = (state) => ({ ...state, isLoading: true });
export const onCreateTicketQuestionsFailure = (state) => ({ ...state, isLoading: false });
export const onCreateTicketQuestionsSuccess = (state, { payload }) => {

  const { data, productOfferId, hitEventId } = payload

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${hitEventId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`], 
        tickets: {
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`].tickets.content.map(ticket => 
              (ticket || {}).productOfferId === productOfferId ?  
              { ...ticket, dynamicInfo: { ...data } } : ticket
            )
        }
      } 
    }
  };

};

export const onDeleteTicketQuestionsRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteTicketQuestionsFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteTicketQuestionsSuccess = (state, { payload }) => {

  const { data, productOfferId, hitEventId } = payload

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${hitEventId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`], 
        tickets: {
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`].tickets.content.map(ticket => 
              (ticket || {}).productOfferId === productOfferId ?  
              { ...ticket, dynamicInfo: null } : ticket
            )
        }
      } 
    }
  };

};

export const onEditTicketQuestionsRequest = (state) => ({ ...state, isLoading: true });
export const onEditTicketQuestionsFailure = (state) => ({ ...state, isLoading: false });
export const onEditTicketQuestionsSuccess = (state, { payload }) => {

  const { data, productOfferId, hitEventId } = payload

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${hitEventId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`], 
        tickets: {
          content: state.hitClubHitEventsDetailPanes[`HITEVENT-${hitEventId}`].tickets.content.map(ticket => 
            (ticket || {}).productOfferId === productOfferId ?  
            { ...ticket, dynamicInfo: { ...data } } : ticket
          )
        }
      } 
    }
  };

};

export const onRemoveTicketRequest = (state) => ({ ...state, isLoading: true });
export const onRemoveTicketFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveTicketSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.params.hitEventId.toString()}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.params.hitEventId.toString()}`], 
        tickets: {
            content: state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.params.hitEventId.toString()}`].tickets.content.filter((ticket) => {
            return ticket.productOfferId.toString() !== payload.params.productOfferId.toString()
          })
        }
      } 
    }
  };

};

export const onCreateMembershipOfferRequest = (state) => ({ ...state, isLoading: true });
export const onCreateMembershipOfferFailure = (state) => ({ ...state, isLoading: false });
export const onCreateMembershipOfferSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitClubs: state.hitClubs.map(hitClub => 
        (hitClub || {}).hitClubId === payload.hitClub.hitClubId ? 
          { ...hitClub, 
            membershipOffers: [ ...hitClub.membershipOffers, payload ]
          } 
          : hitClub
      )
  }

};

export const onRemoveHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onRemoveHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitEventSuccess = (state, { payload }) => {

  return {
    ...state,
    isLoading: false,
    hitClubHitEvents: { 
      ...state.hitClubHitEvents,
      content: [
        ...state.hitClubHitEvents.content.filter(item => item.hitEventId.toString() !== payload.params.hitEventId.toString())
      ]
    }
  };

};

export const onEditMembershipOfferRequest = (state) => ({ ...state, isLoading: true });
export const onEditMembershipOfferFailure = (state) => ({ ...state, isLoading: false });
export const onEditMembershipOfferSuccess = (state, { payload }) => {

  const updatedMembershipOffer = payload.data

  return {
    ...state,
    isLoading: false,
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId.toString() === payload.hitClubId.toString() ? 
        { 
          ...hitClub, 
          membershipOffers: 
            hitClub.membershipOffers.map(membershipOffer => membershipOffer.membershipOfferId.toString() === updatedMembershipOffer.membershipOfferId.toString() ?
              { 
                ...updatedMembershipOffer
              } : membershipOffer
            )
        } : hitClub
    )
  }

};

export const onGetEditMembershipOfferRequest = (state) => ({ ...state, isLoading: true });
export const onGetEditMembershipOfferFailure = (state) => ({ ...state, isLoading: false });
export const onGetEditMembershipOfferSuccess = (state, { payload }) => {

  const updatedMembershipOffer = payload.data

  return {
    ...state,
    isLoading: false,
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId.toString() === payload.hitClubId.toString() ? 
        { 
          ...hitClub, 
          membershipOffers: 
            hitClub.membershipOffers.map(membershipOffer => membershipOffer.membershipOfferId.toString() === updatedMembershipOffer.membershipOfferId.toString() ?
              { 
                ...updatedMembershipOffer
              } : membershipOffer
            )
        } : hitClub
    )
  }

};

export const onDeleteMembershipOfferRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteMembershipOfferFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteMembershipOfferSuccess = (state, { payload }) => {

  const { membershipOfferId, hitClubId } = payload

  const hitClubs = _.cloneDeep(_.get(`hitClubs`)(state) || {});

  if(hitClubs.length) {
    const currentHitClubIndex = hitClubs.findIndex((hitClub) => (
      (hitClub || {}).hitClubId.toString() === hitClubId.toString()
    ));

    if(currentHitClubIndex > -1) {
      hitClubs[currentHitClubIndex].membershipOffers.splice(hitClubs[currentHitClubIndex].membershipOffers.findIndex((item) => {
        return item.membershipOfferId.toString() === membershipOfferId.toString();
      }), 1);

      state.isLoading = false

      return _.set(`hitClubs`, hitClubs)(state);
    
    }
  }

  state.isLoading = false

  return state;

};

export const onConnectInstagramRequest = (state) => ({ ...state, isLoading: true });
export const onConnectInstagramFailure = (state) => ({ ...state, isLoading: false });
export const onConnectInstagramSuccess = (state, { payload }) => {

  return {
    ...state, 
    isLoading: false, 
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId === payload.hitClubId ? 
        { ...hitClub, ...payload } : hitClub
    )
  };

};

export const onDeleteInstagramRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteInstagramFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteInstagramSuccess = (state, { payload }) => {

  return {
    ...state, 
    isLoading: false, 
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId === payload.hitClubId ? 
        { ...hitClub, ...payload } : hitClub
    )
  };

};

export const onGetHitClubMemberLogRequest = (state) => ({ ...state });
export const onGetHitClubMemberLogFailure = (state) => ({ ...state });
export const onGetHitClubMemberLogSuccess = (state, { payload }) => {
  return {
    ...state, 
    hitMemberLogs: {
      [payload.hitMemberId] : payload.data
    }
  };

};

export const onGetHitClubFeedRequest = (state) => ({ ...state, isLoading: true });
export const onGetHitClubFeedFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubFeedSuccess = (state, { payload }) => {
  return {
    ...state, 
    isLoading: false, 
    feeds: {
      ...state.feeds,
      [payload.hitClubId] : payload.data
    }
  };

};

export const onGetHitEventFeedRequest = (state) => ({ ...state, isLoading: true });
export const onGetHitEventFeedFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitEventFeedSuccess = (state, { payload }) => {
  return {
    ...state, 
    isLoading: false, 
    hitEventFeeds: {
      ...state.feeds,
      [payload.hitEventId] : payload.data
    }
  };

};

export const onDeleteStudentPostRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteStudentPostFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteStudentPostSuccess = (state, { payload }) => {

  if(!!payload.hitClubId) {
    return {
      ...state, 
      isLoading: false, 
      feeds: {
        ...state.feeds,
        [payload.hitClubId]: [
          ...state.feeds[payload.hitClubId].filter(post => post.object.studentPostId!==payload.studentPostId)
        ]
      }
    };
  } else if (!!payload.hitEventId) {
    return {
      ...state, 
      isLoading: false, 
      hitEventFeeds: {
        ...state.hitEventFeeds,
        [payload.hitEventId]: [
          ...state.hitEventFeeds[payload.hitEventId].filter(post => post.object.studentPostId!==payload.studentPostId)
        ]
      }
    };
  }
  
};

export const onAddMemberRequest = (state) => ({ ...state, isLoading: true });
export const onAddMemberFailure = (state) => ({ ...state, isLoading: false });
export const onAddMemberSuccess = (state, { payload }) => {
  if(payload.hitMemberStatus !== "CANCELLED_AUTOMATIC_VERIFICATION_DECLINED") {
    return {
      ...state, 
      isLoading: false, 
      hitClubs: state.hitClubs.map(hitClub => 
        (hitClub || {}).hitClubId === payload.hitClub.hitClubId ? 
          { ...hitClub, numberOfMembers: hitClub.numberOfMembers+1 } : hitClub
      ),
      hitClubMembers: {
        content : [
          ...state.hitClubMembers.content,
          payload 
        ],
        totalElements: state.hitClubMembers.totalElements+1, 
        numberOfElements: state.hitClubMembers.numberOfElements+1,
      }
    };
  }
  else {
    return { 
      ...state,
      isLoading: false
    }
  }
};

export const onCreateStudentPostRequest = (state) => ({ ...state, isLoading: true });
export const onCreateStudentPostFailure = (state) => ({ ...state, isLoading: false });
export const onCreateStudentPostSuccess = (state, { payload }) => {

  if(!!payload.hitClubId) {
    return {
      ...state, 
      isLoading: false, 
      feeds: {
        ...state.feeds,
        [payload.hitClubId]: [
          payload.data,
          ...state.feeds[payload.hitClubId]
        ]
      }
    };
  } else if (!!payload.hitEventId) {
    return {
      ...state, 
      isLoading: false, 
      hitEventFeeds: {
        ...state.hitEventFeeds,
        [payload.hitEventId]: [
          payload.data,
          ...state.hitEventFeeds[payload.hitEventId]
        ]
      }
    };
  }

};

export const onEditStudentPostRequest = (state) => ({ ...state, isLoading: true });
export const onEditStudentPostFailure = (state) => ({ ...state, isLoading: false });
export const onEditStudentPostSuccess = (state, { payload }) => {

  if(!!payload.hitClubId) {
    return {
      ...state, 
      isLoading: false, 
      feeds: {
        ...state.feeds,
        [payload.hitClubId]: [
          ...state.feeds[payload.hitClubId].map(post => post.object.studentPostId === payload.data.object.studentPostId ? payload.data : post)
        ]
      }
    };
  }
  else if (!!payload.hitEventId) {
    return {
      ...state, 
      isLoading: false, 
      hitEventFeeds: {
        ...state.hitEventFeeds,
        [payload.hitEventId]: [
          ...state.hitEventFeeds[payload.hitEventId].map(post => post.object.studentPostId === payload.data.object.studentPostId ? payload.data : post)
        ]
      }
    };
  }

};

export const onUpdateMemberStatusRequest = (state) => ({ ...state, isLoading: true });
export const onUpdateMemberStatusFailure = (state) => ({ ...state, isLoading: false });
export const onUpdateMemberStatusSuccess = (state, { payload }) => {
  const { hitMemberId, hitMemberStatus, cancelledReason } = payload

  let currentHitClubMembers = _.cloneDeep(_.get(`hitClubMembers`)(state) || {});

  if(currentHitClubMembers) {
    const memberIndex = currentHitClubMembers.content.findIndex((member) => (
      (member || {}).hitMemberId.toString() === hitMemberId.toString()
    ));
    
    if(memberIndex > -1) {
      currentHitClubMembers.content[memberIndex].hitMemberStatus = hitMemberStatus
      if(!!cancelledReason) {
        currentHitClubMembers.content[memberIndex].cancelledReason = cancelledReason
      }
      state.isLoading = false
      return _.set(`hitClubMembers`, currentHitClubMembers)(state);
    }
  
  }

  return state;

};

export const onImportMembersRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onImportMembersFailure = (state) => ({ ...state, isLoading: false });
export const onImportMembersSuccess = (state, { payload }) => {
  return { 
    ...state, 
    isLoading: false, 
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId === payload.hitClubId ? 
        { ...hitClub, numberOfMembers: hitClub.numberOfMembers.toString() === "0" ? payload.numberOfCreatedMembers : hitClub.numberOfMembers+payload.numberOfCreatedMembers } : hitClub
    ) 
  };
}

export const onGetParametersEditHitEventRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetParametersEditHitEventFailure = (state) => ({ ...state, isLoading: false });
export const onGetParametersEditHitEventSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitClubHitEvents: { 
      ...state.hitClubHitEvents,
      content: state.hitClubHitEvents.content.map(hitEvent => 
        (hitEvent || {}).hitEventId === payload.hitEventId ? 
          { ...hitEvent, ...payload.data } : hitEvent
      )
    }
  };
}

export const onDeleteInstagramPostRequest = (state) => ({ ...state, isLoading: true });
export const onDeleteInstagramPostFailure = (state) => ({ ...state, isLoading: false });
export const onDeleteInstagramPostSuccess = (state, { payload }) => {

  console.log('payload', payload)

  if(!!payload.hitClubId) {
    return {
      ...state, 
      isLoading: false, 
      feeds: {
        ...state.feeds,
        [payload.hitClubId]: [
          ...state.feeds[payload.hitClubId].filter(post => post.object.instagramPostId!==payload.instagramPostId)
        ]
      }
    };
  } else if (!!payload.hitEventId) {
    return {
      ...state, 
      isLoading: false, 
      hitEventFeeds: {
        ...state.hitEventFeeds,
        [payload.hitEventId]: [
          ...state.hitEventFeeds[payload.hitEventId].filter(post => post.object.instagramPostId!==payload.instagramPostId)
        ]
      }
    };
  }

};

export const onGetHitClubProductBasesRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubProductBasesFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubProductBasesSuccess = (state, { payload }) => ({ ...state, isLoading: false, hitClubProducts: payload });

export const onGetHitClubProductBaseRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitClubProductBaseFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitClubProductBaseSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductsDetailPanes: {
      ...state.hitClubProductsDetailPanes,
      [`PRODUCTBASE-${payload.productBaseId}`] : { ...state.hitClubProductsDetailPanes[`PRODUCTBASE-${payload.productBaseId}`], ...payload }
    }
  })
}

export const onCreateHitClubProductBaseRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onCreateHitClubProductBaseFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitClubProductBaseSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProducts: {
      ...state.hitClubProducts,
      content: [ ...state.hitClubProducts.content, payload ]
    },
    hitClubProductsDetailPanes: {
      ...state.hitClubProductsDetailPanes,
      [`PRODUCTBASE-${payload.productBaseId}`] : { ...state.hitClubProductsDetailPanes[`PRODUCTBASE-${payload.productBaseId}`], ...payload }
    }
  })
}

export const onUpdateHitClubProductBaseRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onUpdateHitClubProductBaseFailure = (state) => ({ ...state, isLoading: false });
export const onUpdateHitClubProductBaseSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProducts: {
      ...state.hitClubProducts,
      content: state.hitClubProducts.content.map(productBase => 
        (productBase || {}).productBaseId === payload.productBaseId ? 
          { ...productBase, ...payload } : productBase
      )
    },
    hitClubProductsDetailPanes: {
      ...state.hitClubProductsDetailPanes,
      [`PRODUCTBASE-${payload.productBaseId}`] : { ...payload }
    }
  })
}

export const onRemoveHitClubProductBaseRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onRemoveHitClubProductBaseFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitClubProductBaseSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProducts: {
      ...state.hitClubProducts,
      content: state.hitClubProducts.content.filter((productBase) => {
        return productBase.productBaseId !== payload.productBaseId
      })
    },
    hitClubProductsDetailPanes: delete [`PRODUCTBASE-${payload.productBaseId}`]
  })
}

export const onGetProductGroupsRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetProductGroupsFailure = (state) => ({ ...state, isLoading: false });
export const onGetProductGroupsSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroups: {
      ...state.hitClubProductGroups,
      [`${payload.entityType}-${payload.entityId}`] : payload.data
    }
  })
}

export const onCreateHitEventProductGroupRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onCreateHitEventProductGroupFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitEventProductGroupSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroups: {
      ...state.hitClubProductGroups,
      [`${payload.entityType}-${payload.entityId}`] : {
        ...state.hitClubProductGroups[`${payload.entityType}-${payload.entityId}`],
        content: [
          ...state.hitClubProductGroups[`${payload.entityType}-${payload.entityId}`].content,
          payload.data
        ]
      }
    }
  })
}

export const onEditHitEventProductGroupRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onEditHitEventProductGroupFailure = (state) => ({ ...state, isLoading: false });
export const onEditHitEventProductGroupSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroups: {
      ...state.hitClubProductGroups,
      [`${payload.entityType}-${payload.entityId}`] : {
        ...state.hitClubProductGroups[`${payload.entityType}-${payload.entityId}`],
        content: state.hitClubProductGroups[`${payload.entityType}-${payload.entityId}`].content.map(productGroup => 
            (productGroup || {}).productGroupId === payload.data.productGroupId ? 
              { ...productGroup, ...payload.data } : productGroup
          )
      }
    }
  })
}

export const onRemoveHitEventProductGroupRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onRemoveHitEventProductGroupFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitEventProductGroupSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroups: {
      ...state.hitClubProductGroups,
      [`HIT_EVENT-${payload.hitEventId}`] : {
        ...state.hitClubProductGroups[`HIT_EVENT-${payload.hitEventId}`],
        content: state.hitClubProductGroups[`HIT_EVENT-${payload.hitEventId}`].content.filter(productGroup => {
          return productGroup.productGroupId !== payload.productGroupId
        })
      }
    }
  })
}

export const onGetHitEventProductGroupOffersRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitEventProductGroupOffersFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitEventProductGroupOffersSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroupOffers: {
      ...state.hitClubProductGroupOffers,
      [`PRODUCTGROUP-${payload.productGroupId}`] : { 
        ...payload.data, 
        content: payload.data.pageable.pageNumber !== 0 ? [].concat(state.hitClubProductGroupOffers[`PRODUCTGROUP-${payload.productGroupId}`]?.content||[], payload.data.content) : payload.data.content   
        // [ ...state.hitClubProductGroupOffers[`PRODUCTGROUP-${payload.productGroupId}`].content, payload.data.content ],
      }
    }
  })
}

export const onCreateHitEventProductOfferRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onCreateHitEventProductOfferFailure = (state) => ({ ...state, isLoading: false });
export const onCreateHitEventProductOfferSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroupOffers: {
      ...state.hitClubProductGroupOffers,
      [`PRODUCTGROUP-${payload.productGroupId}`] : {
        content: [
          ...state.hitClubProductGroupOffers[`PRODUCTGROUP-${payload.productGroupId}`].content,
          payload.data
        ]
      }
    }
  })
}

export const onEditHitEventProductOfferRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onEditHitEventProductOfferFailure = (state) => ({ ...state, isLoading: false });
export const onEditHitEventProductOfferSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroupOffers: {
      ...state.hitClubProductGroupOffers,
      [`PRODUCTGROUP-${payload.productGroupId}`] : {
        content: state.hitClubProductGroupOffers[`PRODUCTGROUP-${payload.productGroupId}`].content.map(productOffer => 
          (productOffer || {}).productOfferId === payload.data.productOfferId ? 
            { ...productOffer, ...payload.data } : productOffer
        )
      }
    }
  })
}

export const onRemoveHitEventProductOfferRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onRemoveHitEventProductOfferFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveHitEventProductOfferSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroupOffers: {
      ...state.hitClubProductGroupOffers,
      [`PRODUCTGROUP-${payload.productGroupId}`] : {
        content: state.hitClubProductGroupOffers[`PRODUCTGROUP-${payload.productGroupId}`].content.filter((productOffer) => {
          return productOffer.productOfferId !== payload.productOfferId
        })
      }
    }
  })
}

export const onGetHitEventProductOfferRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onGetHitEventProductOfferFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitEventProductOfferSuccess = (state, { payload }) => {
  return ({
    ...state,
    isLoading: false,
    hitClubProductGroupOffers: {
      ...state.hitClubProductGroupOffers,
      [`PRODUCTGROUP-${payload.productGroupId}`] : {
        content: state.hitClubProductGroupOffers[`PRODUCTGROUP-${payload.productGroupId}`].content.map(productOffer => 
          (productOffer || {}).productOfferId === payload.productOfferId ? 
            { ...productOffer, ...payload.data } : productOffer
        )
      }
    }
  })
}

export const onGetHitEventTicketsRequest = (state) => ({ ...state, isLoading: true });
export const onGetHitEventTicketsFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitEventTicketsSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.hitEventId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.hitEventId}`], 
        tickets: payload.data
      } 
    }
  };
};

export const onGetElectionPostsRequest = (state) => ({ ...state, isLoading: true });
export const onGetElectionPostsFailure = (state) => ({ ...state, isLoading: false });
export const onGetElectionPostsSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionPosts: {
      ...state.hitElectionPosts,
      [`HITEVENT-${payload.hitEventId}`] : payload.data
    }
  };
};

export const onCreateElectionPostRequest = (state) => ({ ...state, isLoading: true });
export const onCreateElectionPostFailure = (state) => ({ ...state, isLoading: false });
export const onCreateElectionPostSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionPosts: {
      ...state.hitElectionPosts,
      [`HITEVENT-${payload.hitEventId}`] : {
        content: [
          ...state.hitElectionPosts[`HITEVENT-${payload.hitEventId}`].content,
          payload.data
        ]
      }
    }
  };
};

export const onUpdateElectionPostRequest = (state) => ({ ...state, isLoading: true });
export const onUpdateElectionPostFailure = (state) => ({ ...state, isLoading: false });
export const onUpdateElectionPostSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionPosts: {
      ...state.hitElectionPosts,
      [`HITEVENT-${payload.hitEventId}`] : {
        content: state.hitElectionPosts[`HITEVENT-${payload.hitEventId}`].content.map(electionPost => 
          (electionPost || {}).electionPostId === payload.data.electionPostId ? 
            { ...electionPost, ...payload.data } : electionPost
        ) 
      } 
    }
  };
};

export const onRemoveElectionPostRequest = (state) => ({ ...state, isLoading: true });
export const onRemoveElectionPostFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveElectionPostSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionPosts: {
      ...state.hitElectionPosts,
      [`HITEVENT-${payload.hitEventId}`] : {
        content: state.hitElectionPosts[`HITEVENT-${payload.hitEventId}`].content.filter((electionPost) => {
          return electionPost.electionPostId !== payload.data.electionPostId
        })
      } 
    }
  };
};

export const onMoveElectionPostRequest = (state) => ({ ...state, isLoading: true });
export const onMoveElectionPostFailure = (state) => ({ ...state, isLoading: false });
export const onMoveElectionPostSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionPosts: {
      ...state.hitElectionPosts,
      [`HITEVENT-${payload.hitEventId}`] : {
        content: payload.data
      } 
    }
  };
};

export const onGetElectionCandidaciesRequest = (state) => ({ ...state, isLoading: true });
export const onGetElectionCandidaciesFailure = (state) => ({ ...state, isLoading: false });
export const onGetElectionCandidaciesSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionCandidacies: {
      ...state.hitElectionCandidacies,
      [`ELECTION_POST-${payload.electionPostId}`] : payload.data
    }
  };
};

export const onCreateElectionCandidacyRequest = (state) => ({ ...state, isLoading: true });
export const onCreateElectionCandidacyFailure = (state) => ({ ...state, isLoading: false });
export const onCreateElectionCandidacySuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionCandidacies: {
      ...state.hitElectionCandidacies,
      [`ELECTION_POST-${payload.electionPostId}`] : {
        content: [
          ...state.hitElectionCandidacies[`ELECTION_POST-${payload.electionPostId}`].content,
          payload.data
        ]
      }
    }
  };
};

export const onUpdateElectionCandidacyRequest = (state) => ({ ...state, isLoading: true });
export const onUpdateElectionCandidacyFailure = (state) => ({ ...state, isLoading: false });
export const onUpdateElectionCandidacySuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionCandidacies: {
      ...state.hitElectionCandidacies,
      [`ELECTION_POST-${payload.electionPostId}`] : {
        content: state.hitElectionCandidacies[`ELECTION_POST-${payload.electionPostId}`].content.map(candidate => 
          (candidate || {}).candidateId === payload.data.candidateId ? 
            { ...candidate, ...payload.data } : candidate
        )
      }
    }
  };
};

export const onRemoveElectionCandidacyRequest = (state) => ({ ...state, isLoading: true });
export const onRemoveElectionCandidacyFailure = (state) => ({ ...state, isLoading: false });
export const onRemoveElectionCandidacySuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionCandidacies: {
      ...state.hitElectionCandidacies,
      [`ELECTION_POST-${payload.electionPostId}`] : {
        ...state.hitElectionCandidacies[`ELECTION_POST-${payload.electionPostId}`],
        content: state.hitElectionCandidacies[`ELECTION_POST-${payload.electionPostId}`].content.filter((candidate) => {
          return candidate.candidateId !== payload.data.candidateId
        }),
        totalElements: state.hitElectionCandidacies[`ELECTION_POST-${payload.electionPostId}`].totalElements-1,
        numberOfElements: state.hitElectionCandidacies[`ELECTION_POST-${payload.electionPostId}`].numberOfElements-1
      }
    }
  };
};

export const onMoveElectionCandidacyRequest = (state) => ({ ...state, isLoading: true });
export const onMoveElectionCandidacyFailure = (state) => ({ ...state, isLoading: false });
export const onMoveElectionCandidacySuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitElectionCandidacies: {
      ...state.hitElectionCandidacies,
      [`ELECTION_POST-${payload.electionPostId}`] : {
        content: payload.data
      } 
    }
  };
};

export const onGetHitEventElectionResultRequest = (state) => ({ ...state, isLoading: true });
export const onGetHitEventElectionResultFailure = (state) => ({ ...state, isLoading: false });
export const onGetHitEventElectionResultSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    hitClubHitEventsDetailPanes: {
      ...state.hitClubHitEventsDetailPanes,
      [`HITEVENT-${payload.hitEventId}`] : { 
        ...state.hitClubHitEventsDetailPanes[`HITEVENT-${payload.hitEventId}`], 
        electionResult: payload.data
      } 
    }
  };
};

export const onMoveMembershipRequest = (state) => ({ ...state});
export const onMoveMembershipFailure = (state) => ({ ...state });
export const onMoveMembershipSuccess = (state, { payload }) => {

  return {
    ...state,
    hitClubs: state.hitClubs.map(hitClub => 
      (hitClub || {}).hitClubId.toString() === payload.hitClubId.toString() ? 
        { 
          ...hitClub, 
          membershipOffers: payload.data
        } : hitClub
    )
  }

};

export const onGetActiveSubMembershipsRequest = (state, { params }) => ({ ...state });
export const onGetActiveSubMembershipsFailure = (state) => ({ ...state});
export const onGetActiveSubMembershipsSuccess = (state, { payload }) => {  
  return { 
    ...state, 
    hitClubActiveSubMemberships: {
      [payload.hitMemberId] : payload.data
    }
  };
}


export const ACTION_HANDLERS = {
  [HITCLUB.GET_HITCLUBS_MENU_REQUEST]: onGetHitClubsMenuRequest,
  [HITCLUB.GET_HITCLUBS_MENU_FAILURE]: onGetHitClubsMenuFailure,
  [HITCLUB.GET_HITCLUBS_MENU_SUCCESS]: onGetHitClubsMenuSuccess,
  [HITCLUB.GET_HITCLUB_REQUEST]: onGetHitClubRequest,
  [HITCLUB.GET_HITCLUB_FAILURE]: onGetHitClubFailure,
  [HITCLUB.GET_HITCLUB_SUCCESS]: onGetHitClubSuccess,
  [HITCLUB.GET_HITCLUBS_REQUEST]: onGetHitClubsRequest,
  [HITCLUB.GET_HITCLUBS_FAILURE]: onGetHitClubsFailure,
  [HITCLUB.GET_HITCLUBS_SUCCESS]: onGetHitClubsSuccess,
  [HITCLUB.GET_HITCLUB_MEMBERS_REQUEST]: onGetHitClubMembersRequest,
  [HITCLUB.GET_HITCLUB_MEMBERS_FAILURE]: onGetHitClubMembersFailure,
  [HITCLUB.GET_HITCLUB_MEMBERS_SUCCESS]: onGetHitClubMembersSuccess,
  [HITCLUB.GET_HITCLUB_MEMBERS_REQUESTS_REQUEST]: onGetHitClubMembersRequestsRequest,
  [HITCLUB.GET_HITCLUB_MEMBERS_REQUESTS_FAILURE]: onGetHitClubMembersRequestsFailure,
  [HITCLUB.GET_HITCLUB_MEMBERS_REQUESTS_SUCCESS]: onGetHitClubMembersRequestsSuccess,
  [HITCLUB.GET_HITCLUB_HITEVENT_REQUEST]: onGetHitClubHitEventRequest,
  [HITCLUB.GET_HITCLUB_HITEVENT_FAILURE]: onGetHitClubHitEventFailure,
  [HITCLUB.GET_HITCLUB_HITEVENT_SUCCESS]: onGetHitClubHitEventSuccess,
  [HITCLUB.GET_HITCLUB_HITEVENTS_REQUEST]: onGetHitClubHitEventsRequest,
  [HITCLUB.GET_HITCLUB_HITEVENTS_FAILURE]: onGetHitClubHitEventsFailure,
  [HITCLUB.GET_HITCLUB_HITEVENTS_SUCCESS]: onGetHitClubHitEventsSuccess,
  [HITCLUB.CREATE_HITCLUB_REQUEST]: onCreateHitClubRequest,
  [HITCLUB.CREATE_HITCLUB_FAILURE]: onCreateHitClubFailure,
  [HITCLUB.CREATE_HITCLUB_SUCCESS]: onCreateHitClubSuccess,
  [HITCLUB.EDIT_HITCLUB_REQUEST]: onEditHitClubRequest,
  [HITCLUB.EDIT_HITCLUB_FAILURE]: onEditHitClubFailure,
  [HITCLUB.EDIT_HITCLUB_SUCCESS]: onEditHitClubSuccess,
  [HITCLUB.CREATE_HITEVENT_REQUEST]: onCreateHitEventRequest,
  [HITCLUB.CREATE_HITEVENT_FAILURE]: onCreateHitEventFailure,
  [HITCLUB.CREATE_HITEVENT_SUCCESS]: onCreateHitEventSuccess,
  [HITCLUB.EDIT_HITEVENT_REQUEST]: onEditHitEventRequest,
  [HITCLUB.EDIT_HITEVENT_FAILURE]: onEditHitEventFailure,
  [HITCLUB.EDIT_HITEVENT_SUCCESS]: onEditHitEventSuccess,

  [HITCLUB.APPROVE_MEMBER_REQUEST]: onApproveMemberRequest,
  [HITCLUB.APPROVE_MEMBER_FAILURE]: onApproveMemberFailure,
  [HITCLUB.APPROVE_MEMBER_SUCCESS]: onApproveMemberSuccess,

  [HITCLUB.APPROVE_MEMBERS_REQUEST]: onApproveMembersRequest,
  [HITCLUB.APPROVE_MEMBERS_FAILURE]: onApproveMembersFailure,
  [HITCLUB.APPROVE_MEMBERS_SUCCESS]: onApproveMembersSuccess,

  [HITCLUB.CREATE_CLUB_OWNER_REQUEST]: onCreateHitClubOwnerRequest,
  [HITCLUB.CREATE_CLUB_OWNER_FAILURE]: onCreateHitClubOwnerFailure,
  [HITCLUB.CREATE_CLUB_OWNER_SUCCESS]: onCreateHitClubOwnerSuccess,
  [HITCLUB.CREATE_CLUB_OWNER_OTHER_REQUEST]: onCreateHitClubOwnerOtherRequest,
  [HITCLUB.CREATE_CLUB_OWNER_OTHER_FAILURE]: onCreateHitClubOwnerOtherFailure,
  [HITCLUB.CREATE_CLUB_OWNER_OTHER_SUCCESS]: onCreateHitClubOwnerOtherSuccess,
  [HITCLUB.REMOVE_CLUB_OWNER_SUCCESS]: onRemoveHitClubOwnerSuccess,
  [HITCLUB.EDIT_HITMEMBER_SUCCESS] : onEditHitMemberSuccess,
  [HITCLUB.REMOVE_HITMEMBER_SUCCESS] : onRemoveHitMemberSuccess,
  [HITCLUB.CREATE_TICKET_REQUEST]: onCreateTicketRequest,
  [HITCLUB.CREATE_TICKET_FAILURE]: onCreateTicketFailure,
  [HITCLUB.CREATE_TICKET_SUCCESS]: onCreateTicketSuccess,
  [HITCLUB.EDIT_TICKET_REQUEST]: onEditTicketRequest,
  [HITCLUB.EDIT_TICKET_FAILURE]: onEditTicketFailure,
  [HITCLUB.EDIT_TICKET_SUCCESS]: onEditTicketSuccess,

  [HITCLUB.CREATE_TICKET_QUESTIONS_REQUEST]: onCreateTicketQuestionsRequest,
  [HITCLUB.CREATE_TICKET_QUESTIONS_FAILURE]: onCreateTicketQuestionsFailure,
  [HITCLUB.CREATE_TICKET_QUESTIONS_SUCCESS]: onCreateTicketQuestionsSuccess,

  [HITCLUB.DELETE_TICKET_QUESTIONS_REQUEST]: onDeleteTicketQuestionsRequest,
  [HITCLUB.DELETE_TICKET_QUESTIONS_FAILURE]: onDeleteTicketQuestionsFailure,
  [HITCLUB.DELETE_TICKET_QUESTIONS_SUCCESS]: onDeleteTicketQuestionsSuccess,

  [HITCLUB.EDIT_TICKET_QUESTIONS_REQUEST]: onEditTicketQuestionsRequest,
  [HITCLUB.EDIT_TICKET_QUESTIONS_FAILURE]: onEditTicketQuestionsFailure,
  [HITCLUB.EDIT_TICKET_QUESTIONS_SUCCESS]: onEditTicketQuestionsSuccess,
  [HITCLUB.REMOVE_TICKET_REQUEST]: onRemoveTicketRequest,
  [HITCLUB.REMOVE_TICKET_FAILURE]: onRemoveTicketFailure,
  [HITCLUB.REMOVE_TICKET_SUCCESS]: onRemoveTicketSuccess,
  [HITCLUB.CREATE_MEMBERSHIP_OFFER_REQUEST]: onCreateMembershipOfferRequest,
  [HITCLUB.CREATE_MEMBERSHIP_OFFER_FAILURE]: onCreateMembershipOfferFailure,
  [HITCLUB.CREATE_MEMBERSHIP_OFFER_SUCCESS]: onCreateMembershipOfferSuccess,
  [HITCLUB.EDIT_MEMBERSHIP_OFFER_REQUEST]: onEditMembershipOfferRequest,
  [HITCLUB.EDIT_MEMBERSHIP_OFFER_FAILURE]: onEditMembershipOfferFailure,
  [HITCLUB.EDIT_MEMBERSHIP_OFFER_SUCCESS]: onEditMembershipOfferSuccess,
  [HITCLUB.GET_EDIT_MEMBERSHIP_OFFER_REQUEST]: onGetEditMembershipOfferRequest,
  [HITCLUB.GET_EDIT_MEMBERSHIP_OFFER_FAILURE]: onGetEditMembershipOfferFailure,
  [HITCLUB.GET_EDIT_MEMBERSHIP_OFFER_SUCCESS]: onGetEditMembershipOfferSuccess,
  [HITCLUB.DELETE_MEMBERSHIP_OFFER_REQUEST]: onDeleteMembershipOfferRequest,
  [HITCLUB.DELETE_MEMBERSHIP_OFFER_FAILURE]: onDeleteMembershipOfferFailure,
  [HITCLUB.DELETE_MEMBERSHIP_OFFER_SUCCESS]: onDeleteMembershipOfferSuccess,
  [HITCLUB.REMOVE_HITEVENT_REQUEST]: onRemoveHitEventRequest,
  [HITCLUB.REMOVE_HITEVENT_FAILURE]: onRemoveHitEventFailure,
  [HITCLUB.REMOVE_HITEVENT_SUCCESS]: onRemoveHitEventSuccess,
  [HITCLUB.CONNECT_INSTAGRAM_REQUEST]: onConnectInstagramRequest,
  [HITCLUB.CONNECT_INSTAGRAM_FAILURE]: onConnectInstagramFailure,
  [HITCLUB.CONNECT_INSTAGRAM_SUCCESS]: onConnectInstagramSuccess,
  [HITCLUB.DELETE_INSTAGRAM_REQUEST]: onDeleteInstagramRequest,
  [HITCLUB.DELETE_INSTAGRAM_FAILURE]: onDeleteInstagramFailure,
  [HITCLUB.DELETE_INSTAGRAM_SUCCESS]: onDeleteInstagramSuccess,
  [HITCLUB.MEMBER_LOG_REQUEST]: onGetHitClubMemberLogRequest,
  [HITCLUB.MEMBER_LOG_FAILURE]: onGetHitClubMemberLogFailure,
  [HITCLUB.MEMBER_LOG_SUCCESS]: onGetHitClubMemberLogSuccess,
  [HITCLUB.ADD_MEMBER_REQUEST]: onAddMemberRequest,
  [HITCLUB.ADD_MEMBER_FAILURE]: onAddMemberFailure,
  [HITCLUB.ADD_MEMBER_SUCCESS]: onAddMemberSuccess,
  [HITCLUB.GET_FEED_REQUEST]: onGetHitClubFeedRequest,
  [HITCLUB.GET_FEED_FAILURE]: onGetHitClubFeedFailure,
  [HITCLUB.GET_FEED_SUCCESS]: onGetHitClubFeedSuccess,
  [HITCLUB.GET_HITEVENT_FEED_REQUEST]: onGetHitEventFeedRequest,
  [HITCLUB.GET_HITEVENT_FEED_FAILURE]: onGetHitEventFeedFailure,
  [HITCLUB.GET_HITEVENT_FEED_SUCCESS]: onGetHitEventFeedSuccess,
  [HITCLUB.DELETE_STUDENT_POST_REQUEST]: onDeleteStudentPostRequest,
  [HITCLUB.DELETE_STUDENT_POST_FAILURE]: onDeleteStudentPostFailure,
  [HITCLUB.DELETE_STUDENT_POST_SUCCESS]: onDeleteStudentPostSuccess,
  [HITCLUB.CREATE_STUDENT_POST_REQUEST]: onCreateStudentPostRequest,
  [HITCLUB.CREATE_STUDENT_POST_FAILURE]: onCreateStudentPostFailure,
  [HITCLUB.CREATE_STUDENT_POST_SUCCESS]: onCreateStudentPostSuccess,
  [HITCLUB.EDIT_STUDENT_POST_REQUEST]: onEditStudentPostRequest,
  [HITCLUB.EDIT_STUDENT_POST_FAILURE]: onEditStudentPostFailure,
  [HITCLUB.EDIT_STUDENT_POST_SUCCESS]: onEditStudentPostSuccess,
  [HITCLUB.UPDATE_MEMBER_STATUS_REQUEST] : onUpdateMemberStatusRequest,
  [HITCLUB.UPDATE_MEMBER_STATUS_FAILURE] : onUpdateMemberStatusFailure,
  [HITCLUB.UPDATE_MEMBER_STATUS_SUCCESS] : onUpdateMemberStatusSuccess,
  [HITCLUB.IMPORT_MEMBERS_REQUEST] : onImportMembersRequest,
  [HITCLUB.IMPORT_MEMBERS_FAILURE] : onImportMembersFailure,
  [HITCLUB.IMPORT_MEMBERS_SUCCESS] : onImportMembersSuccess,
  [HITCLUB.EDIT_HITEVENT_PARAMETERS_REQUEST] : onGetParametersEditHitEventRequest,
  [HITCLUB.EDIT_HITEVENT_PARAMETERS_FAILURE] : onGetParametersEditHitEventFailure,
  [HITCLUB.EDIT_HITEVENT_PARAMETERS_SUCCESS] : onGetParametersEditHitEventSuccess,
  // [HITCLUB.CREATE_TICKET_PARAMETERS_REQUEST] : onGetParametersCreateTicketRequest,
  // [HITCLUB.CREATE_TICKET_PARAMETERS_FAILURE] : onGetParametersCreateTicketFailure,
  // [HITCLUB.CREATE_TICKET_PARAMETERS_SUCCESS] : onGetParametersCreateTicketSuccess,
  // [HITCLUB.EDIT_TICKET_PARAMETERS_REQUEST] : onGetParametersEditTicketRequest,
  // [HITCLUB.EDIT_TICKET_PARAMETERS_FAILURE] : onGetParametersEditTicketFailure,
  // [HITCLUB.EDIT_TICKET_PARAMETERS_SUCCESS] : onGetParametersEditTicketSuccess,
  [HITCLUB.DELETE_INSTAGRAM_POST_REQUEST] : onDeleteInstagramPostRequest,
  [HITCLUB.DELETE_INSTAGRAM_POST_FAILURE] : onDeleteInstagramPostFailure,
  [HITCLUB.DELETE_INSTAGRAM_POST_SUCCESS] : onDeleteInstagramPostSuccess,
  [COMPANY.GET_HITEVENTS_REQUEST]: onGetHitClubHitEventsRequest,
  [COMPANY.GET_HITEVENTS_FAILURE]: onGetHitClubHitEventsFailure,
  [COMPANY.GET_HITEVENTS_SUCCESS]: onGetHitClubHitEventsSuccess,
  [HITCLUB.GET_PRODUCT_BASE_REQUEST]: onGetHitClubProductBaseRequest,
  [HITCLUB.GET_PRODUCT_BASE_FAILURE]: onGetHitClubProductBaseFailure,
  [HITCLUB.GET_PRODUCT_BASE_SUCCESS]: onGetHitClubProductBaseSuccess,
  [HITCLUB.GET_PRODUCT_BASES_REQUEST]: onGetHitClubProductBasesRequest,
  [HITCLUB.GET_PRODUCT_BASES_FAILURE]: onGetHitClubProductBasesFailure,
  [HITCLUB.GET_PRODUCT_BASES_SUCCESS]: onGetHitClubProductBasesSuccess,
  [HITCLUB.GET_PRODUCT_BASES_DEBOUNCED_REQUEST]: onGetHitClubProductBasesRequest,
  [HITCLUB.GET_PRODUCT_BASES_DEBOUNCED_FAILURE]: onGetHitClubProductBasesFailure,
  [HITCLUB.GET_PRODUCT_BASES_DEBOUNCED_SUCCESS]: onGetHitClubProductBasesSuccess,

  [HITCLUB.CREATE_PRODUCT_BASE_REQUEST]: onCreateHitClubProductBaseRequest,
  [HITCLUB.CREATE_PRODUCT_BASE_FAILURE]: onCreateHitClubProductBaseFailure,
  [HITCLUB.CREATE_PRODUCT_BASE_SUCCESS]: onCreateHitClubProductBaseSuccess,

  [HITCLUB.UPDATE_PRODUCT_BASE_REQUEST]: onUpdateHitClubProductBaseRequest,
  [HITCLUB.UPDATE_PRODUCT_BASE_FAILURE]: onUpdateHitClubProductBaseFailure,
  [HITCLUB.UPDATE_PRODUCT_BASE_SUCCESS]: onUpdateHitClubProductBaseSuccess,

  [HITCLUB.REMOVE_PRODUCT_BASE_REQUEST]: onRemoveHitClubProductBaseRequest,
  [HITCLUB.REMOVE_PRODUCT_BASE_FAILURE]: onRemoveHitClubProductBaseFailure,
  [HITCLUB.REMOVE_PRODUCT_BASE_SUCCESS]: onRemoveHitClubProductBaseSuccess,

  [HITCLUB.GET_PRODUCT_GROUPS_REQUEST]: onGetProductGroupsRequest,
  [HITCLUB.GET_PRODUCT_GROUPS_FAILURE]: onGetProductGroupsFailure,
  [HITCLUB.GET_PRODUCT_GROUPS_SUCCESS]: onGetProductGroupsSuccess,  

  [HITCLUB.CREATE_HITEVENT_PRODUCT_GROUP_REQUEST]: onCreateHitEventProductGroupRequest,
  [HITCLUB.CREATE_HITEVENT_PRODUCT_GROUP_FAILURE]: onCreateHitEventProductGroupFailure,
  [HITCLUB.CREATE_HITEVENT_PRODUCT_GROUP_SUCCESS]: onCreateHitEventProductGroupSuccess,

  [HITCLUB.EDIT_HITEVENT_PRODUCT_GROUP_REQUEST]: onEditHitEventProductGroupRequest,
  [HITCLUB.EDIT_HITEVENT_PRODUCT_GROUP_FAILURE]: onEditHitEventProductGroupFailure,
  [HITCLUB.EDIT_HITEVENT_PRODUCT_GROUP_SUCCESS]: onEditHitEventProductGroupSuccess,

  [HITCLUB.REMOVE_HITEVENT_PRODUCT_GROUP_REQUEST]: onRemoveHitEventProductGroupRequest,
  [HITCLUB.REMOVE_HITEVENT_PRODUCT_GROUP_FAILURE]: onRemoveHitEventProductGroupFailure,
  [HITCLUB.REMOVE_HITEVENT_PRODUCT_GROUP_SUCCESS]: onRemoveHitEventProductGroupSuccess,

  [HITCLUB.GET_HITEVENT_PRODUCT_GROUP_OFFERS_REQUEST]: onGetHitEventProductGroupOffersRequest,
  [HITCLUB.GET_HITEVENT_PRODUCT_GROUP_OFFERS_FAILURE]: onGetHitEventProductGroupOffersFailure,
  [HITCLUB.GET_HITEVENT_PRODUCT_GROUP_OFFERS_SUCCESS]: onGetHitEventProductGroupOffersSuccess,

  [HITCLUB.CREATE_HITEVENT_PRODUCT_OFFER_REQUEST]: onCreateHitEventProductOfferRequest,
  [HITCLUB.CREATE_HITEVENT_PRODUCT_OFFER_FAILURE]: onCreateHitEventProductOfferFailure,
  [HITCLUB.CREATE_HITEVENT_PRODUCT_OFFER_SUCCESS]: onCreateHitEventProductOfferSuccess,

  [HITCLUB.EDIT_HITEVENT_PRODUCT_OFFER_REQUEST]: onEditHitEventProductOfferRequest,
  [HITCLUB.EDIT_HITEVENT_PRODUCT_OFFER_FAILURE]: onEditHitEventProductOfferFailure,
  [HITCLUB.EDIT_HITEVENT_PRODUCT_OFFER_SUCCESS]: onEditHitEventProductOfferSuccess,

  [HITCLUB.REMOVE_HITEVENT_PRODUCT_OFFER_REQUEST]: onRemoveHitEventProductOfferRequest,
  [HITCLUB.REMOVE_HITEVENT_PRODUCT_OFFER_FAILURE]: onRemoveHitEventProductOfferFailure,
  [HITCLUB.REMOVE_HITEVENT_PRODUCT_OFFER_SUCCESS]: onRemoveHitEventProductOfferSuccess,

  [HITCLUB.GET_HITEVENT_PRODUCT_OFFER_REQUEST]: onGetHitEventProductOfferRequest,
  [HITCLUB.GET_HITEVENT_PRODUCT_OFFER_FAILURE]: onGetHitEventProductOfferFailure,
  [HITCLUB.GET_HITEVENT_PRODUCT_OFFER_SUCCESS]: onGetHitEventProductOfferSuccess,

  [HITCLUB.GET_HITEVENT_TICKETS_REQUEST]: onGetHitEventTicketsRequest,
  [HITCLUB.GET_HITEVENT_TICKETS_FAILURE]: onGetHitEventTicketsFailure,
  [HITCLUB.GET_HITEVENT_TICKETS_SUCCESS]: onGetHitEventTicketsSuccess,

  [HITCLUB.GET_TICKET_QUESTIONS_REQUEST]: onGetTicketQuestionsRequest,
  [HITCLUB.GET_TICKET_QUESTIONS_FAILURE]: onGetTicketQuestionsFailure,
  [HITCLUB.GET_TICKET_QUESTIONS_SUCCESS]: onGetTicketQuestionsSuccess,
  
  [HITCLUB.GET_EDIT_TICKET_INFO_REQUEST]: onGetEditTicketInformationRequest,
  [HITCLUB.GET_EDIT_TICKET_INFO_FAILURE]: onGetEditTicketInformationFailure,
  [HITCLUB.GET_EDIT_TICKET_INFO_SUCCESS]: onGetEditTicketInformationSuccess,

  // [HITCLUB.GET_EDIT_PRODUCT_GROUP_INFO_REQUEST]: onGetEditProductOfferInformationRequest,
  // [HITCLUB.GET_EDIT_PRODUCT_GROUP_INFO_FAILURE]: onGetEditProductOfferInformationFailure,
  // [HITCLUB.GET_EDIT_PRODUCT_GROUP_INFO_SUCCESS]: onGetEditProductOfferInformationSuccess,
  
  [HITCLUB.CREATE_ELECTION_POST_REQUEST]: onCreateElectionPostRequest,
  [HITCLUB.CREATE_ELECTION_POST_FAILURE]: onCreateElectionPostFailure,
  [HITCLUB.CREATE_ELECTION_POST_SUCCESS]: onCreateElectionPostSuccess,

  [HITCLUB.GET_ELECTION_POSTS_REQUEST]: onGetElectionPostsRequest,
  [HITCLUB.GET_ELECTION_POSTS_FAILURE]: onGetElectionPostsFailure,
  [HITCLUB.GET_ELECTION_POSTS_SUCCESS]: onGetElectionPostsSuccess,

  [HITCLUB.GET_CANDIDACIES_REQUEST]: onGetElectionCandidaciesRequest,
  [HITCLUB.GET_CANDIDACIES_FAILURE]: onGetElectionCandidaciesFailure,
  [HITCLUB.GET_CANDIDACIES_SUCCESS]: onGetElectionCandidaciesSuccess,

  [HITCLUB.CREATE_CANDIDACY_REQUEST]: onCreateElectionCandidacyRequest,
  [HITCLUB.CREATE_CANDIDACY_FAILURE]: onCreateElectionCandidacyFailure,
  [HITCLUB.CREATE_CANDIDACY_SUCCESS]: onCreateElectionCandidacySuccess,

  [HITCLUB.UPDATE_ELECTION_POST_REQUEST]: onUpdateElectionPostRequest,
  [HITCLUB.UPDATE_ELECTION_POST_FAILURE]: onUpdateElectionPostFailure,
  [HITCLUB.UPDATE_ELECTION_POST_SUCCESS]: onUpdateElectionPostSuccess,

  [HITCLUB.REMOVE_ELECTION_POST_REQUEST]: onRemoveElectionPostRequest,
  [HITCLUB.REMOVE_ELECTION_POST_FAILURE]: onRemoveElectionPostFailure,
  [HITCLUB.REMOVE_ELECTION_POST_SUCCESS]: onRemoveElectionPostSuccess,
  
  [HITCLUB.MOVE_ELECTION_POST_REQUEST]: onMoveElectionPostRequest,
  [HITCLUB.MOVE_ELECTION_POST_FAILURE]: onMoveElectionPostFailure,
  [HITCLUB.MOVE_ELECTION_POST_SUCCESS]: onMoveElectionPostSuccess,

  [HITCLUB.UPDATE_CANDIDACY_REQUEST]: onUpdateElectionCandidacyRequest,
  [HITCLUB.UPDATE_CANDIDACY_FAILURE]: onUpdateElectionCandidacyFailure,
  [HITCLUB.UPDATE_CANDIDACY_SUCCESS]: onUpdateElectionCandidacySuccess,

  [HITCLUB.REMOVE_CANDIDACY_REQUEST]: onRemoveElectionCandidacyRequest,
  [HITCLUB.REMOVE_CANDIDACY_FAILURE]: onRemoveElectionCandidacyFailure,
  [HITCLUB.REMOVE_CANDIDACY_SUCCESS]: onRemoveElectionCandidacySuccess,

  [HITCLUB.MOVE_CANDIDACY_REQUEST]: onMoveElectionCandidacyRequest,
  [HITCLUB.MOVE_CANDIDACY_FAILURE]: onMoveElectionCandidacyFailure,
  [HITCLUB.MOVE_CANDIDACY_SUCCESS]: onMoveElectionCandidacySuccess,

  [HITCLUB.HITEVENT_ELECTION_RESULT_REQUEST]: onGetHitEventElectionResultRequest,
  [HITCLUB.HITEVENT_ELECTION_RESULT_FAILURE]: onGetHitEventElectionResultFailure,
  [HITCLUB.HITEVENT_ELECTION_RESULT_SUCCESS]: onGetHitEventElectionResultSuccess,

  [HITCLUB.MOVE_MEMBERSHIP_REQUEST]: onMoveMembershipRequest,
  [HITCLUB.MOVE_MEMBERSHIP_FAILURE]: onMoveMembershipFailure,
  [HITCLUB.MOVE_MEMBERSHIP_SUCCESS]: onMoveMembershipSuccess,

  [HITCLUB.GET_HITCLUB_ACTIVE_SUBMEMBERSHIPS_REQUEST]: onGetActiveSubMembershipsRequest,
  [HITCLUB.GET_HITCLUB_ACTIVE_SUBMEMBERSHIPS_FAILURE]: onGetActiveSubMembershipsFailure,
  [HITCLUB.GET_HITCLUB_ACTIVE_SUBMEMBERSHIPS_SUCCESS]: onGetActiveSubMembershipsSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
